import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import React from 'react'
import { ChatSourceType, setChatSource } from '../../store/slices/IeqGptSlice';
import { useAppDispatch, useAppSelector } from '../../store/store';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
export const UNIT_DATA = {
    INTERNAL: 'chat',
    EXTERNAL: 'chat_ext',
    // IEQ: 'saas',
}
export const ChatSourceTypeData: ChatSourceType[] = [
    { name: "Internal", value: UNIT_DATA?.INTERNAL, theme: { primary: "rgb(86 124 195)" }, subTitle: 'AI Based Topic Generation Based on IEQ Source Library', icon: "./assets/images/lock.png", iconWhite: "./assets/images/lock-white.png", LockMui: <LockOutlinedIcon /> },
    { name: "External", value: UNIT_DATA?.EXTERNAL, theme: { primary: "rgb(86 124 195)" }, subTitle: 'Generative AI Based on Internet Sources', icon: "./assets/images/unlocked.png", iconWhite: "./assets/images/unlocked-white.png", LockMui: <LockOpenOutlinedIcon /> },
    // { name: "IEQ", value: UNIT_DATA?.IEQ, theme: { primary: "#5cd916" }, subTitle: 'Generative AI Based on IEQMAX User Interface' },

]
const InternalExternal = () => {
    const dispatch = useAppDispatch();
    const chatSourceType = useAppSelector(store => store?.IeqGptSlice?.currentType);
    return (
        <>
            <ToggleButtonGroup
                color="primary"
                value={chatSourceType?.value}
                exclusive
                onChange={(e, value) => { }}
                sx={{
                    border: `2px solid ${chatSourceType?.theme?.primary}`,
                    padding: "0.2rem 0.22rem 0.25rem 0.25rem !important",
                    borderRadius: 5,
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "0 !important",
                    width: 'auto',
                    height: '2rem',
                    marginTop: '0.5rem'
                }}
            >
                {ChatSourceTypeData?.map((value, index) => {
                    return (
                        <ToggleButton key={index} value={value?.value} sx={{
                            padding: "0px 10px !important",
                            width: "50%",
                            border: '0px',
                            borderRadius: '20px !important',
                            background: (chatSourceType?.value === value?.value ? `${chatSourceType?.theme?.primary} !important` : "transparent"),
                        }}
                            onClick={() => {
                                dispatch(setChatSource(value));
                            }}
                        >
                            <Typography sx={{ textTransform: 'capitalize', margin: '0px', color: (chatSourceType?.value === value?.value ? "#fff" : "#000"), display: "flex", alignItems: 'center', gap: "2px" }} variant="body1" gutterBottom>
                                {value?.LockMui} {value?.name}
                            </Typography>
                        </ToggleButton>
                    )
                })}
            </ToggleButtonGroup>
        </>
    )
}

export default InternalExternal;